export const paginationConstants = {
    PAGINATION_REQUEST: 'PAGING_REQUEST'
}
